<template>
  <div>
    <review-signature-request-dialog
      v-if="currentSignatureRequest && currentCompany"
      :key="currentSignatureRequest.id"
      :opened.sync="reviewSignatureRequestDialogOpened"
      :currentCompany="currentCompany"
      :signatureRequest="currentSignatureRequest"
    />
  </div>
</template>

<script>
import API from '@/api';
import ReviewSignatureRequestDialog from '@/components/dialogs/ReviewSignatureRequestDialog';

export default {
  components: {
    ReviewSignatureRequestDialog,
  },

  data() {
    return {
      currentSignatureRequest: null,
      currentCompany: null,
      reviewSignatureRequestDialogOpened: false,
    };
  },

  computed: {
    signatureRequestId() {
      return this.$route.params.id;
    },

    currentCompanyId() {
      return this.$route.query.companyId;
    },
  },

  methods: {
    async getCurrentCompany() {
      const response = await API.company.getCompany(this.currentCompanyId);
      this.currentCompany = response.data;
    },

    async getSignatureRequest() {
      const response = await API.signatureRequest.getSignatureRequest({
        id: this.signatureRequestId,
        companyId: this.currentCompanyId,
      });

      this.currentSignatureRequest = response.data;
    },
  },

  async created() {
    await this.getCurrentCompany();
    await this.getSignatureRequest();
    this.reviewSignatureRequestDialogOpened = true;
  },
};
</script>

<style></style>
